module.exports = __webpack_public_path__ + "assets/img/img70.8ced0601.png";